<template>
  <div
    v-if="!loading"
    class="align-start ml-auto gap-5 flex justify-end">
    <template v-if="canAgree">
      <RejectDialog
        :application.sync="item"
        class-name="reject-btn"
        :disabled="elements.length > 0 || agree_loading"
        :elements.sync="elements"
        :loading="agree_loading"
        @callback="val => agree(false, val)"/>
      <sButton
        :disabled="elements.length > 0 || agree_loading"
        :loading="agree_loading"
        @click="agree(true, '')">
        {{ $t('Application.Confirm') }}
      </sButton>
    </template>
    <sButton
      v-else-if="(item.rows && item.rows.length > 0) || !canAgree"
      :to="{ name: 'purchasing', params: { org: $route.params.org } }">
      {{ $t('Common.Close') }}
    </sButton>
  </div>
</template>
<script>
import RejectDialog from 'components/purchasing/purch item/RejectDialog.vue'

import ApplicationsApi from '@/api/applicationApi'
const api = new ApplicationsApi()

export default {
  name: 'PurchaseAgrreBlock',
  data() {
    return {
      agree_loading: false,
    }
  },
  methods: {
    async agree(decision, comm) {
      this.agree_loading = true
      await api.agreeApplication(this.applicationId, decision, comm)
        .then(res => this.agreeApplicationCallback(res, decision))
        .catch(res => this.$log_error(res))
        .finally(() => this.agree_loading = false)
    },
    async agreeApplicationCallback() {
      this.$emit('getAcceptors')
    },
  },
  props: {
    item: {
      type: Object,
      default: () => ({})
    },
    elements: {
      type: Array,
      default: () => ([])
    },
    canAgree: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
  },
  components: {
    RejectDialog,
  }
}
</script>
